import { DateTime } from 'luxon';
import React, { useCallback, useState } from 'react';
import './TelemetryCard.scss';
import { formatValueWithUnit, limitDecimals } from 'components/Value/utils';
import Icons, { Size } from 'components/Common/Icons';
import PropTypes from 'prop-types';
import { Button, ButtonVariant, Flex, Tooltip } from '@patternfly/react-core';

import { formatTelemetryUnit } from 'utils/dtdl';
import { useTranslation } from 'localization/useTranslation';
import ChartViewModal from 'components/Chart/ChartViewModal';
import { Aggregation } from 'services/constants';
import { formatTimestamp } from 'utils/time';


const TelemetryCard = ({ telemetrySchema, telemetryValue, assetId, light, hideUnit = false, hideChart = false }) => {
  const T = useTranslation();

  const cardClass = light ? 'telemetry-card-light' : 'telemetry-card';

  const [viewSignal, setViewSignal] = useState(null);

  const onCloseChartView = useCallback(() => {
    setViewSignal(null);
  }, []);

  const showChartView = useCallback(() => {
    setViewSignal({
      assetId,
      signals: [{
        fullName: telemetrySchema.displayName,
        name: telemetrySchema.name,
        component: telemetrySchema.componentName,
        type: telemetrySchema.schema,
        aggregate: Aggregation.MEAN
      }]
    });
  }, [assetId, telemetrySchema.componentName, telemetrySchema.displayName, telemetrySchema.name, telemetrySchema.schema]);
  return (
    <>
      <div className={`${cardClass}`}>
        <Flex alignItems={{ default: 'alignItemsCenter' }} justifyContent={{ default: 'justifyContentSpaceBetween' }}>
          <h4>{ telemetrySchema.displayName || telemetrySchema.name }</h4>
          { telemetrySchema.description &&
                      <Tooltip
                        content={telemetrySchema.description}
                      >
                        <Icons.Info size={Size.SMALL}/>
                      </Tooltip>
          }
        </Flex>
        <Flex alignItems={{ default: 'alignItemsCenter' }} justifyContent={{ default: 'justifyContentSpaceBetween' }}>
          <p
            className="telemetry-card-value">
            { hideUnit ? limitDecimals(telemetryValue?.value) : formatValueWithUnit(limitDecimals(telemetryValue?.value), T.localize(formatTelemetryUnit(telemetrySchema?.unit))) }
          </p>
          { !hideChart && <Button onClick={showChartView} variant={ButtonVariant.plain}><Icons.ChartLine size={Size.LARGE}/></Button> }
        </Flex>
        <div className="telemetry-card-timestamp-relative">
          <p>
            { formatTimestamp(DateTime.fromISO(telemetryValue?.timestamp)) }
          </p>
        </div>
      </div>
      <ChartViewModal isOpen={viewSignal != null} onClose={onCloseChartView} signal={viewSignal}/>
    </>
  );
};

TelemetryCard.propTypes = {
  telemetrySchema: PropTypes.shape({
    displayName: PropTypes.string,
    name: PropTypes.string,
    schema: PropTypes.string,
    unit: PropTypes.string,
    componentName: PropTypes.string
  }).isRequired,
  telemetryValue: PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]).isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(DateTime)])
  }),
  assetId: PropTypes.string.isRequired,
  light: PropTypes.bool,
  hideUnit: PropTypes.bool,
  hideChart: PropTypes.bool
};

export default TelemetryCard;
